import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Button } from 'antd';


class Previw extends Component {
  state = { visible: true };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleOk = () => {
    this.setState({
      visible: false,
    });
  }

  render() {
    let { visible } = this.state
    let { filePath, type } = this.props
    return (
      <Modal 
       width="900px" 
       bodyStyle={{padding:'10px 20px 30px'}}
       visible={visible} 
       onCancel={this.handleCancel} 
       onOk={this.handleOk}
       footer={null}
       title="预览"
       centered>
        <div style={{height:'450px'}}>
          <embed src={filePath} type={type} width="100%" height="100%"></embed>
        </div>
      </Modal>
    );
  }
}

const httpfn = (option,cb) => {
  // let { url, data, method } = option
  // const callback = (res) => {
  //   console.log(res)
  // }
  // commonClient.simplecall(url, data, callback)


  let { url, data, method } = option
  let request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} }
  if (data) {
    request.body = data
  }
  let xhr = new XMLHttpRequest();
  xhr.open(method, url, true);
  xhr.setRequestHeader('Content-Type', `application/json`);
  xhr.responseType = "blob";
  xhr.onload = function () {
    if (this.status == 200) {
      cb(this.response)
    }else if(this.status == 404){
      tool.popMessage('无可预览文件', "error");
    }
  }
  xhr.send(JSON.stringify(request));
}


export const PreviewFile = (filePath, type, callback) => {
  const div = document.createElement('div')
  document.body.appendChild(div)

  const cancelCallback = () => {
      const result = ReactDOM.unmountComponentAtNode(div)
      if (result && div.parentNode) {
          div.parentNode.removeChild(div)
      }
      callback && callback()
  }

  ReactDOM.render(
      <Previw
          filePath={filePath}
          type={type}
          cancelCallback={cancelCallback}
      />,
      div
  )
}

function base64ToBlob(code) {
  code = code.replace(/[\n\r]/g, '');
  var raw = window.atob(code);
  let rawLength = raw.length;
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], {type: 'application/pdf'});
}

export const PreviewFileAysnc = (id, type="application/pdf") => {
  // 判断是地址
  let isUrl = id.indexOf('http')!==-1
  if(isUrl) {
    return PreviewFile(id)
  }

  if(type==='base64'){
    let blob=base64ToBlob(id)
    let blobURL = window.URL.createObjectURL(blob)
    PreviewFile(blobURL)
    return
  }
  // 判断是文件流
  console.log(id)
  let callback = function (res) {
    if (res) {
      let filePath = URL.createObjectURL(new Blob([res],{type: "application/pdf"}))
      PreviewFile(filePath, type)
    }
  }
  httpfn({
    url: sgiConfig.allUrl.filePreview + '/' + id, 
    data: null,
    method: 'get'
  },callback)
}

export const dynamicPreview = (option, type="application/pdf") => {
  console.log(option)
  httpfn(option, (res) => {
    if (res) {
      let filePath = URL.createObjectURL(new Blob([res],{type: "application/pdf"}))
      PreviewFile(filePath, type)
    }
  })
}


// WEBPACK FOOTER //
// ./apps/pages/component/FilePreview.js